import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useLayoutEffect
} from "react";
import Quagga from "quagga";

const QuaggaScanner = forwardRef(({ onDetected, onClose, podeLerRef }, ref) => {
  const scannerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    stop: () => {
      try {
        Quagga.stop();
      } catch (e) {
        console.warn("[QuaggaScanner] Quagga.stop() falhou ao parar via ref:", e.message);
      }
    }
  }));

  useLayoutEffect(() => {
    if (!scannerRef.current) {
      console.warn("[QuaggaScanner] scannerRef não está pronto.");
      return;
    }

    console.log("[QuaggaScanner] Iniciando Quagga...");
    try {
      Quagga.stop();
    } catch (e) {
      console.warn("[QuaggaScanner] Quagga.stop() falhou (possivelmente não iniciado ainda):", e.message);
    }

    Quagga.init(
      {
        inputStream: {
          type: "LiveStream",
          target: scannerRef.current,
          constraints: {
            facingMode: "environment",
            width: { ideal: 600 },
            height: { ideal: 480 }
          }
        },
        decoder: {
          readers: ["code_128_reader"] // ⚠️ Apenas code_128
        },
        locate: true,
        halfSample: false // melhora leitura em celulares
      },
      (err) => {
        if (err) {
          console.error("[QuaggaScanner] Erro ao iniciar Quagga:", err);
          return;
        }

        console.log("[QuaggaScanner] Quagga iniciado com sucesso.");
        Quagga.start();

        const video = scannerRef.current?.querySelector("video");
        if (video) {
          video.style.objectFit = "cover";
          video.style.width = "100%";
          video.style.height = "60vh";
          console.log("[QuaggaScanner] Estilo do vídeo aplicado.");
        }
      }
    );

    let lastReadTime = 0;

    const onDetectHandler = async (data) => {
      const now = Date.now();

      if (!podeLerRef?.current) {
        console.log("[QuaggaScanner] Leitura bloqueada (podeLerRef.current = false).");
        return;
      }

      if (now - lastReadTime < 2000) {
        console.log("[QuaggaScanner] Aguardando delay de 2s. Ignorando leitura.");
        return;
      }

      const code = data?.codeResult?.code;
      if (code) {
        let corrigido = code.normalize("NFD").replace(/\p{Diacritic}/gu, "").trim().toUpperCase();

        // Se não começa com "CAR", adiciona prefixo
        if (!corrigido.startsWith("CAR")) {
          const numeros = corrigido.replace(/\D/g, "");
          corrigido = `CAR${numeros}`;
        }

        // Validação simples
        if (corrigido.length < 6 || /[^A-Z0-9]/.test(corrigido)) {
          console.warn("[QuaggaScanner] Código suspeito ignorado:", corrigido);
          return;
        }

        lastReadTime = now;
        podeLerRef.current = false;

        console.log("[QuaggaScanner] Código final:", corrigido);

        try {
          await onDetected(corrigido);
        } catch (e) {
          console.error("[QuaggaScanner] Erro durante onDetected:", e);
        }

        setTimeout(() => {
          podeLerRef.current = true;
          console.log("[QuaggaScanner] Leitura liberada novamente após delay.");
        }, 2000);
      } else {
        console.warn("[QuaggaScanner] Dados de leitura inválidos:", data);
      }
    };

    Quagga.onDetected(onDetectHandler);

    return () => {
      Quagga.offDetected(onDetectHandler);
      try {
        Quagga.stop();
        console.log("[QuaggaScanner] Scanner parado e listener removido.");
      } catch (e) {
        console.warn("[QuaggaScanner] Quagga.stop() falhou no cleanup:", e.message);
      }
    };
  }, [onDetected, podeLerRef]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        zIndex: 9999,
        paddingTop: "3rem"
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "0.5rem",
          borderRadius: "6px",
          maxWidth: "400px",
          width: "90%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div
          ref={scannerRef}
          style={{
            width: "100%",
            height: "60vh",
            borderRadius: "8px",
            overflow: "hidden",
            background: "#000"
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: "0.5rem"
          }}
        >
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#00996D",
              color: "white",
              padding: "0.6rem 0.8rem",
              fontSize: "0.90rem",
              borderRadius: "4px",
              border: "none"
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
});

export default QuaggaScanner;
